<template>
    <v-dialog v-model="dialog" max-width="520px">
        <template v-slot:activator="{ on }">
            <v-text-field
                :value="currentValue"
                append-icon="mdi-translate"
                :label="label"
                @click="dialog = true"
                class="activator"
                readonly>
            </v-text-field>
        </template>
        <div class="langs-container">
            <div v-for="(translation, locale) in value" :key="locale">
                <v-icon class="flag-icon d-inline-block">$vuetify.icons.{{ locale }}</v-icon>
                <v-text-field
                    class="lang-input d-inline-block"
                    :label="label + ' [' + locale + ']'"
                    :value="translation"
                    @change="setTranslation(locale, $event)"
                    @keydown.enter="dialog = false">
                </v-text-field>
            </div>
        </div>
    </v-dialog>
</template>

<script>
    import i18n from "@/plugins/vuei18n";

    export default {
        name: "translatable-text-field",
        props: ['label', 'value'],
        computed: {
            currentValue() {
                return this.value[i18n.locale]
            }
        },
        data() {
            return {
                dialog: false
            }
        },
        methods: {
            setTranslation(locale, translation) {
                let value = Object.assign({}, this.value)
                value[locale] = translation
                this.$emit('input', value)
            }
        }
    }
</script>

<style>
    .flag-icon {
        margin-right: 12px;
    }
    .activator input {
        cursor: pointer;
    }
    .langs-container {
        padding: 40px;
        background: white;
    }
    .lang-input {
        width: 80%;
    }
</style>
